import { useEffect, useState } from "react";
import { XIcon } from "@heroicons/react/outline";

const InvoiceFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  loading,
  initialData = null,
}) => {
  const [form, setForm] = useState({
    invoice_no: "",
    status: "",
    amount: "",
  });

  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) return;

    if (initialData) {
      setForm({
        invoice_no: initialData.invoice_no || "",
        status: initialData.status || "",
        amount: initialData.amount || "",
      });
    }

    setError("");
  }, [isOpen, initialData]);

  if (!isOpen) return null;

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setError("");
  };

  const handleSubmit = () => {
    onSubmit(form, setError);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-full max-w-lg bg-slate-900 border border-white/10 rounded-xl shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h2 className="text-lg font-semibold text-white">
            Edit Invoice
          </h2>
          <button onClick={onClose} className="text-slate-400">
            <XIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">
          <div>
            <label className="text-sm text-slate-300 mb-1 block">
              Invoice No
            </label>
            <input
              value={form.invoice_no}
              onChange={(e) =>
                handleChange("invoice_no", e.target.value)
              }
              className="input"
            />
          </div>

          <div>
            <label className="text-sm text-slate-300 mb-1 block">
              Status
            </label>
            <input
              value={form.status}
              onChange={(e) =>
                handleChange("status", e.target.value)
              }
              className="input"
            />
          </div>

          <div>
            <label className="text-sm text-slate-300 mb-1 block">
              Amount
            </label>
            <input
              value={form.amount}
              onChange={(e) =>
                handleChange("amount", e.target.value)
              }
              className="input"
            />
          </div>

          {error && (
            <div className="bg-red-500/10 border border-red-500/20 text-red-400 text-sm px-4 py-2 rounded-lg">
              {error}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">
          <button
            onClick={onClose}
            className="btn-secondary"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="btn-primary"
          >
            {loading ? "Saving..." : "Update Invoice"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceFormModal;
